'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _TableBody = require('./TableBody');
var _TableBody2 = _interopRequireDefault(_TableBody);
var _TableHeader = require('./TableHeader');
var _TableHeader2 = _interopRequireDefault(_TableHeader);
var _DataTableFooter = require('./DataTableFooter');
var _DataTableFooter2 = _interopRequireDefault(_DataTableFooter);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A Data Table component that supports column grouping. Column grouping is defined based on the structure
 * of the column configuration that is passed in through the columns prop. See prop description for further details.
 * Right now, the data table only supports column grouping one level down. For instance, right now, you can only have a
 * one parent cell for a group that only has one level of children.
 */
var DataTableBase = function (_Component) {
  _inherits(DataTableBase, _Component);
  function DataTableBase(props) {
    _classCallCheck(this, DataTableBase);
    var _this = _possibleConstructorReturn(this, (DataTableBase.__proto__ || Object.getPrototypeOf(DataTableBase)).call(this, props));
    var columns = props.columns,
      defaultSortColumn = props.defaultSortColumn,
      defaultSortDirection = props.defaultSortDirection,
      filterable = props.filterable;
    var sortDirection = defaultSortDirection || 'ASCEND';
    var sortColumn = defaultSortColumn || null;
    var flatColumns = _this.flattenColumnData(columns);
    if (!sortColumn && columns.length > 0) {
      var firstSortableColumn = flatColumns.findIndex(function (column) {
        return column.sorting;
      });
      if (firstSortableColumn > -1) {
        sortColumn = flatColumns[firstSortableColumn].value;
      }
    }
    var filters = {};
    if (filterable) {
      filters = _this.getEmptyFilters(flatColumns);
    }
    _this.state = {
      currentPage: 1,
      filters: filters,
      sortColumn: sortColumn,
      sortDirection: sortDirection
    };
    _this.handlePageChange = _this.handlePageChange.bind(_this);
    _this.sortClickHandler = _this.sortClickHandler.bind(_this);
    _this.filterSelectionHandler = _this.filterSelectionHandler.bind(_this);
    _this.clearFiltersHandler = _this.clearFiltersHandler.bind(_this);
    return _this;
  }
  _createClass(DataTableBase, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var newData = nextProps.data,
          itemsPerPage = nextProps.itemsPerPage;
        var currentPage = this.state.currentPage;
        var topPageRange = newData.length === 0 ? 1 : Math.ceil(newData.length / itemsPerPage);
        if (currentPage > topPageRange) {
          this.setState({
            currentPage: topPageRange
          });
        }
      }
      return componentWillReceiveProps;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
          columns = _props.columns,
          className = _props.className;
        var flatTableData = this.flattenTableData();
        var flatColumns = this.flattenColumnData(columns);

        /*
          First step: Filter table data
        */
        var filteredTableData = this.applyFilters(flatTableData, flatColumns);

        /*
          Second step: Sort table data
        */
        var sortedTableData = this.sortTableData(filteredTableData);

        /*
          Third step: retrieve paginated slice of data
        */
        var paginatedData = this.getPaginatedData(sortedTableData);
        return columns.length > 0 ? _react2['default'].createElement('div', {
          className: className
        }, _react2['default'].createElement('table', null, this.renderTableHeader(flatColumns, flatTableData), this.renderTableBody(flatColumns, paginatedData)), this.renderTableFooter(filteredTableData)) : null;
      }
      return render;
    }()
  }, {
    key: 'renderTableHeader',
    value: function () {
      function renderTableHeader(flatColumns, flatTableData) {
        var _state = this.state,
          filters = _state.filters,
          sortColumn = _state.sortColumn,
          sortDirection = _state.sortDirection;
        var filterable = this.props.filterable;
        var isTableGrouped = this.checkIfTableGrouped(flatColumns);
        var filterValues = this.getAllFilterValues(flatColumns, flatTableData);
        var tableHeaderProps = {
          columns: flatColumns,
          filterable: filterable,
          filters: filters,
          filterSelectionHandler: this.filterSelectionHandler,
          filterValues: filterValues,
          isTableGrouped: isTableGrouped,
          sortClickHandler: this.sortClickHandler,
          sortColumn: sortColumn,
          sortDirection: sortDirection
        };
        return _react2['default'].createElement(_TableHeader2['default'], tableHeaderProps);
      }
      return renderTableHeader;
    }()
  }, {
    key: 'renderTableBody',
    value: function () {
      function renderTableBody(flatColumns, paginatedData) {
        var tableBodyMessage = this.props.tableBodyMessage;
        var tableBodyProps = {
          columns: flatColumns,
          data: paginatedData,
          tableBodyMessage: tableBodyMessage
        };
        return _react2['default'].createElement(_TableBody2['default'], tableBodyProps);
      }
      return renderTableBody;
    }()
  }, {
    key: 'renderTableFooter',
    value: function () {
      function renderTableFooter(filteredTableData) {
        var _state2 = this.state,
          currentPage = _state2.currentPage,
          filters = _state2.filters;
        var _props2 = this.props,
          itemsPerPage = _props2.itemsPerPage,
          labelDataType = _props2.labelDataType,
          paginator = _props2.paginator,
          filterable = _props2.filterable;
        var areFiltersApplied = Object.keys(filters).findIndex(function (filterId) {
          return filters[filterId].length > 0;
        }) > -1;
        if (filterable && areFiltersApplied || paginator) {
          return _react2['default'].createElement(_DataTableFooter2['default'], {
            areFiltersApplied: areFiltersApplied,
            clearFiltersHandler: this.clearFiltersHandler,
            currentPage: currentPage,
            filterable: filterable,
            itemsPerPage: itemsPerPage,
            labelDataType: labelDataType || '',
            paginator: paginator,
            onPageClick: this.handlePageChange,
            totalItems: filteredTableData.length
          });
        }
        return null;
      }
      return renderTableFooter;
    }()
  }, {
    key: 'handlePageChange',
    value: function () {
      function handlePageChange(newPage) {
        this.setState({
          currentPage: newPage
        });
      }
      return handlePageChange;
    }()
  }, {
    key: 'sortClickHandler',
    value: function () {
      function sortClickHandler(columnValue) {
        var _state3 = this.state,
          sortColumn = _state3.sortColumn,
          sortDirection = _state3.sortDirection;
        var newSortDirection = 'ASCEND';
        if (columnValue === sortColumn) {
          newSortDirection = sortDirection === 'ASCEND' ? 'DESCEND' : 'ASCEND';
        }
        this.setState({
          sortColumn: columnValue,
          sortDirection: newSortDirection
        });
      }
      return sortClickHandler;
    }()
  }, {
    key: 'filterSelectionHandler',
    value: function () {
      function filterSelectionHandler(selectedValues, columnValue) {
        var filters = this.state.filters;
        var newFilters = _extends({}, filters, _defineProperty({}, columnValue, selectedValues));
        this.setState({
          currentPage: 1,
          filters: newFilters
        });
      }
      return filterSelectionHandler;
    }()
  }, {
    key: 'clearFiltersHandler',
    value: function () {
      function clearFiltersHandler() {
        var filters = this.state.filters;
        var emptyFilters = Object.keys(filters).reduce(function (acc, filterId) {
          acc[filterId] = [];
          return acc;
        }, {});
        this.setState({
          currentPage: 1,
          filters: emptyFilters
        });
      }
      return clearFiltersHandler;
    }()
  }, {
    key: 'flattenTableData',
    value: function () {
      function flattenTableData() {
        var _this2 = this;
        var _props3 = this.props,
          data = _props3.data,
          columns = _props3.columns;
        var parentColumnList = columns.reduce(function (acc, column) {
          if (column.columns && column.columns.length > 0) {
            acc.push(column.value);
          }
          return acc;
        }, []);
        if (parentColumnList.length > 0) {
          return data.map(function (row) {
            return Object.keys(row).reduce(function (acc, rowValue) {
              if (parentColumnList.includes(rowValue)) {
                var rowData = row[rowValue];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                  for (var _iterator = Object.keys(rowData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var value = _step.value;
                    var childValue = _this2.getChildValue(rowValue, value);
                    acc[childValue] = rowData[value];
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                      _iterator['return']();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              } else {
                acc[rowValue] = row[rowValue];
              }
              return acc;
            }, {});
          });
        }
        return data;
      }
      return flattenTableData;
    }()
  }, {
    key: 'sortTableData',
    value: function () {
      function sortTableData(data) {
        var _state4 = this.state,
          sortColumn = _state4.sortColumn,
          sortDirection = _state4.sortDirection;
        var sortedData = data;
        if (sortColumn && sortDirection) {
          var sorter = this.getSortCompareFunction();
          if (sorter) {
            sortedData = [].concat(_toConsumableArray(data)).sort(function (a, b) {
              return sorter(a[sortColumn], b[sortColumn]);
            });
            if (sortDirection === 'DESCEND') {
              sortedData = sortedData.reverse();
            }
          }
        }
        return sortedData;
      }
      return sortTableData;
    }()
  }, {
    key: 'flattenColumnData',
    value: function () {
      function flattenColumnData(columns) {
        var _this3 = this;
        return columns.reduce(function (acc, column) {
          if (column.columns && column.columns.length > 0) {
            var childColumns = column.columns.map(function (childColumn, index) {
              var childValue = _this3.getChildValue(column.value, childColumn.value);
              var isLastChild = index === column.columns.length - 1;
              return _extends({}, childColumn, {
                isChild: true,
                lastChild: isLastChild,
                value: childValue
              });
            });
            acc.push.apply(acc, [_extends({}, column, {
              columns: [],
              childCount: childColumns.length
            })].concat(_toConsumableArray(childColumns)));
          } else {
            acc.push(_extends({}, column, {
              columns: [],
              childCount: 0
            }));
          }
          return acc;
        }, []);
      }
      return flattenColumnData;
    }()
  }, {
    key: 'checkIfTableGrouped',
    value: function () {
      function checkIfTableGrouped(flatColumns) {
        return flatColumns.findIndex(function (column) {
          return column.childCount > 0;
        }) > -1;
      }
      return checkIfTableGrouped;
    }()
  }, {
    key: 'getSortCompareFunction',
    value: function () {
      function getSortCompareFunction() {
        var sortColumn = this.state.sortColumn;
        var columns = this.props.columns;
        var column = columns.find(function (column) {
          return column.value === sortColumn;
        });
        if (column && column.sorting) {
          return column.sorter ? column.sorter : this.defaultSorter;
        } else {
          return null;
        }
      }
      return getSortCompareFunction;
    }()
  }, {
    key: 'defaultSorter',
    value: function () {
      function defaultSorter(a, b) {
        var sortValueA = a;
        var sortValueB = b;
        if (a.hasOwnProperty('value')) {
          sortValueA = a.value;
        }
        if (b.hasOwnProperty('value')) {
          sortValueB = b.value;
        }
        if (sortValueA > sortValueB) {
          return 1;
        }
        if (sortValueA < sortValueB) {
          return -1;
        }
        return 0;
      }
      return defaultSorter;
    }()
  }, {
    key: 'getAllFilterValues',
    value: function () {
      function getAllFilterValues(flatColumns, flatTableData) {
        var filterable = this.props.filterable;
        if (filterable) {
          var filterValues = this.getFilterValues(flatColumns, flatTableData);
          var customFilterValues = this.getCustomFilterValues(flatColumns);
          return _extends({}, filterValues, customFilterValues);
        } else {
          return null;
        }
      }
      return getAllFilterValues;
    }()
  }, {
    key: 'getEmptyFilters',
    value: function () {
      function getEmptyFilters(flatColumns) {
        return flatColumns.reduce(function (acc, column) {
          var value = column.value,
            childCount = column.childCount,
            isChild = column.isChild;
          if (childCount === 0 || isChild) {
            acc[value] = [];
          }
          return acc;
        }, {});
      }
      return getEmptyFilters;
    }()
  }, {
    key: 'getFilterValues',
    value: function () {
      function getFilterValues(flatColumns, flatTableData) {
        var emptyFilters = this.getEmptyFilters(flatColumns);
        return flatTableData.reduce(function (acc, rowData) {
          var _loop = function () {
            function _loop(columnValue) {
              var filterColumn = acc[columnValue];
              var rowValue = rowData[columnValue];
              if ((typeof rowValue === 'undefined' ? 'undefined' : _typeof(rowValue)) === 'object' && rowValue.value) {
                rowValue = rowValue.value;
              }
              if (filterColumn.findIndex(function (filter) {
                return filter.name === rowValue;
              }) === -1) {
                filterColumn.push({
                  name: rowValue,
                  value: rowValue
                });
              }
            }
            return _loop;
          }();
          for (var columnValue in rowData) {
            _loop(columnValue);
          }
          return acc;
        }, emptyFilters);
      }
      return getFilterValues;
    }()
  }, {
    key: 'getCustomFilterValues',
    value: function () {
      function getCustomFilterValues(flatColumns) {
        return flatColumns.reduce(function (acc, column) {
          var customFilters = column.customFilters,
            value = column.value;
          if (customFilters && customFilters.length > 0) {
            acc[value] = customFilters.map(function (filter) {
              return {
                value: filter.value,
                name: filter.name
              };
            });
          }
          return acc;
        }, {});
      }
      return getCustomFilterValues;
    }()
  }, {
    key: 'applyFilters',
    value: function () {
      function applyFilters(flatTableData, flatColumns) {
        var _this4 = this;
        var filterable = this.props.filterable;
        var filteredData = flatTableData;
        if (filterable) {
          var filters = this.getActiveFiltersWithCustom(flatColumns);
          if (filters) {
            filteredData = flatTableData.filter(function (tableRow) {
              return Object.keys(filters).reduce(function (shouldKeepRow, filterValue) {
                if (shouldKeepRow) {
                  var _rowValue = tableRow[filterValue];
                  var filterValues = filters[filterValue];
                  if (_this4.areFiltersCustom(filterValues)) {
                    shouldKeepRow = _this4.checkCustomFilters(_rowValue, filterValues);
                  } else {
                    if ((typeof _rowValue === 'undefined' ? 'undefined' : _typeof(_rowValue)) === 'object' && _rowValue.value) {
                      _rowValue = _rowValue.value;
                    }
                    shouldKeepRow = filterValues.indexOf(_rowValue) > -1;
                  }
                }
                return shouldKeepRow;
              }, true);
            });
          }
        }
        return filteredData;
      }
      return applyFilters;
    }()
  }, {
    key: 'getActiveFiltersWithCustom',
    value: function () {
      function getActiveFiltersWithCustom(flatColumns) {
        var _this5 = this;
        var filters = this.state.filters;
        return Object.keys(filters).reduce(function (acc, filterValue) {
          var filterList = filters[filterValue];
          if (filterList.length > 0) {
            var customFilters = _this5.getCustomFilters(flatColumns, filterValue);
            if (customFilters && customFilters.length > 0) {
              acc[filterValue] = filterList.map(function (filter) {
                return customFilters.find(function (customFilter) {
                  return customFilter.value === filter;
                });
              });
            } else {
              acc[filterValue] = filterList;
            }
          }
          return acc;
        }, {});
      }
      return getActiveFiltersWithCustom;
    }()
  }, {
    key: 'getCustomFilters',
    value: function () {
      function getCustomFilters(columns, filterValue) {
        return columns.find(function (column) {
          return column.value === filterValue;
        }).customFilters;
      }
      return getCustomFilters;
    }()
  }, {
    key: 'areFiltersCustom',
    value: function () {
      function areFiltersCustom(filters) {
        return filters.findIndex(function (filter) {
          return (typeof filter === 'undefined' ? 'undefined' : _typeof(filter)) === 'object';
        }) > -1;
      }
      return areFiltersCustom;
    }()
  }, {
    key: 'checkCustomFilters',
    value: function () {
      function checkCustomFilters(value, filters) {
        var allFilters = filters.map(function (filter) {
          return filter.value;
        });
        return filters.reduce(function (acc, filter) {
          if (acc) {
            var filterValue = filter.value,
              filterMethod = filter.method;
            var filterCellValue = value;
            if ((typeof filterCellValue === 'undefined' ? 'undefined' : _typeof(filterCellValue)) === 'object') {
              filterCellValue = filterCellValue.name;
            }
            acc = filterMethod(filterCellValue, filterValue, allFilters);
          }
          return acc;
        }, true);
      }
      return checkCustomFilters;
    }()
  }, {
    key: 'getPaginatedData',
    value: function () {
      function getPaginatedData(data) {
        var currentPage = this.state.currentPage;
        var _props4 = this.props,
          itemsPerPage = _props4.itemsPerPage,
          paginator = _props4.paginator;
        if (paginator) {
          var startPageIndex = (currentPage - 1) * itemsPerPage;
          var endPageIndex = startPageIndex + itemsPerPage;
          return data.slice(startPageIndex, endPageIndex);
        }
        return data;
      }
      return getPaginatedData;
    }()
  }, {
    key: 'getChildValue',
    value: function () {
      function getChildValue(parentValue, childValue) {
        /*
          We need to make the child values unique based off of
          the combination of the child's parent value and its own
          value.
        */
        return parentValue + '-' + childValue;
      }
      return getChildValue;
    }()
  }]);
  return DataTableBase;
}(_react.Component);
DataTableBase.defaultProps = {
  columns: [],
  data: [],
  filterable: false,
  itemsPerPage: 10,
  labelDataType: null,
  paginator: false,
  tableBodyMessage: '',
  isHeaderSticky: false
};
DataTableBase.propTypes = {
  /**
   * An array of column configuration objects where a name and value are the only required fields for a column object.
   * In order to enable column grouping, a columns value can be added to a top level column object. The Columns value
   * needs to be an array of column objects where a name and value are required.
   *
   * If you would like a column to be sortable, meaning the user can change the sort direction for a column, then you need to mark
   * that column as sortable in the column config. You do this by including a sorting property for the column, which is a boolean value
   * designating whether or not that column can be sorted on. If you would like to use the default sorter, which is a basic compare function,
   * you do not need to include a custom sorter through the sorter property on the column config. If the default sorter function does not work
   * for your data, you can pass a sorter function as the sorter property in the config.
   * The sorter function is a compare function that follows the same API as the compareFunction used in the Array.prototype.sort function ([found here](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)).
   *
   * Sample:
   *
   * ```json
   * [
   *   {
   *     value: 'sample',
   *     name: 'Sample Grouped Column',
   *     columns: [
   *       { value: 'child1', name: 'Child Column 1', sorting: true, sorter: sorterFunction },
   *       { value: 'child2', name: 'Child Column 2', sorting: true, sorter: sorterFunction }
   *     ]
   *   }
   * ]
   * ```
   */
  columns: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
    value: _propTypes2['default'].string.isRequired,
    name: _propTypes2['default'].node.isRequired,
    sorting: _propTypes2['default'].bool,
    sorter: _propTypes2['default'].func,
    customFilters: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      name: _propTypes2['default'].string.isRequired,
      value: _propTypes2['default'].string.isRequired,
      method: _propTypes2['default'].func.isRequired
    })),
    columns: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      value: _propTypes2['default'].string.isRequired,
      name: _propTypes2['default'].node.isRequired,
      sorting: _propTypes2['default'].bool,
      sorter: _propTypes2['default'].func,
      customFilters: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        name: _propTypes2['default'].string.isRequired,
        value: _propTypes2['default'].string.isRequired,
        method: _propTypes2['default'].func.isRequired
      }))
    }))
  })),
  /**
   * An array of objects where each object in the array represents a row of data in the data table.
   * The row objects need to be structured so that the values in the object match the value of the value from the
   * column configuration passed through in the columns prop.
   */
  data: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].number]))),
  /**
   * A string value representing the default column to sort by. This will provide a default
   * sort column for the first render. If you do not provide a default sort column, then the
   * table will use the first sortable column as the default. This string value
   * must match exactly the name of the column designated by the **value** for that column
   * used within the data passed through the **column** prop.
   */
  defaultSortColumn: _propTypes2['default'].string,
  /**
   * A string value for the default sort direction. The string must be either **ASCEND** or **DESCEND**.
   */
  defaultSortDirection: _propTypes2['default'].oneOf(['ASCEND', 'DESCEND']),
  /**
   * A boolean value designating whether or not you want the header to be sticky.
   */
  isHeaderSticky: _propTypes2['default'].bool,
  /**
   * A boolean value designating whether or not you want to the table to allow filtering.
   */
  filterable: _propTypes2['default'].bool,
  /* A number value that determines how many items per page will be shown in the Data Table if the paginator is enabled */
  itemsPerPage: _propTypes2['default'].number,
  /* A string value that determines the title for the label, displaying ___ of____ 'labelDataType' */
  labelDataType: _propTypes2['default'].string,
  /* A boolean value that determines whether or not a Paginator is shown with the Data Table */
  paginator: _propTypes2['default'].bool,
  /* A string or a React element that is shown in the table when there is no data.  */
  tableBodyMessage: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].element])
};
DataTableBase.displayName = 'DataTable';
exports['default'] = DataTableBase;